import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useSearchItemReserveRelese() {
  const { startListen } = useWebSocketStore()
  const { updateSearchCar } = useUpdateCar()

  const itemReserveRelease = () => {
    startListen({
      eventName: 'premium.ITEM_RESERVE_RELEASE',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, itemId, free } = event.context

        updateSearchCar(itemId || carId, (data) => {
          return {
            ...data,
            state: free ? 'SOLD' : 'NOT_SOLD',
          }
        })
      },
    })
  }

  return { itemReserveRelease }
}
